<div class="col-md-6 offset-md-3 mt-5">
    <router-outlet></router-outlet>
</div>